import { useContext, useRef } from 'react'
import useIsomorphicLayoutEffect from 'hooks/useIsomorphicLayoutEffect'
import { DrawerSurfaceEntryContext } from '../contexts/DrawerSurfaceEntryContext'
import { TurnAuthoritySnapshotContext } from '../contexts/TurnAuthoritySnapshotContext'

// Preserve open order when a drawer's title/details change during hydration.
export function useSurfaceDrawerRegistration(isOpen: boolean, label: string | undefined) {
  const snapshot = useContext(TurnAuthoritySnapshotContext)
  const centralEntryId = useContext(DrawerSurfaceEntryContext)
  const owner = useRef(Symbol('visible drawer')).current
  useIsomorphicLayoutEffect(() => {
    if (!snapshot || !isOpen) return
    snapshot.current.visibleDrawers ??= new Map()
    snapshot.current.visibleDrawers.set(owner, { label, centralEntryId })
  }, [centralEntryId, isOpen, label, owner, snapshot])
  useIsomorphicLayoutEffect(() => {
    if (!snapshot || !isOpen) return
    return () => { snapshot.current.visibleDrawers?.delete(owner) }
  }, [isOpen, owner, snapshot])
}
